import axios from "axios";
import UserService from "./UserService";

axios.interceptors.request.use(function (config) {
  // Do something before request is sent
  var loginInfo = UserService.getUserInfo();
  if(loginInfo) {
    config.headers.Authorization =  `BEARER ${loginInfo.token}`;
  }
  return config;
}, function (error) {
  // Do something with request error
  return Promise.reject(error);
});
